export default __webpack_public_path__ + "static/media/quiz_bg.0b6adb01.png";